import FilterNone from '@mui/icons-material/FilterNone';
import UpdateIcon from '@mui/icons-material/Update';
import { Box, CircularProgress, List, TextField, Tooltip, Typography } from '@mui/material';
import { lightBlue, red } from '@mui/material/colors';
import dayjs from 'dayjs';
import { action, computed, makeObservable, observable, reaction, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import Configuracao from '../../util/Configuracao';
import ReactComponent from '../ReactComponent';
import IconeLimpar from './icones/IconeLimpar';

class PecasProcesso extends ReactComponent {
    valorCampoPesquisa = '';

    constructor(props) {
        super(props);

        makeObservable(this, {
            valorCampoPesquisa: observable,
            registro: computed,
            sessaoId: computed,
            abrirDocumento: action,
            sublinhar: action,
            retirarSublinhar: action,
            pecasProcesso: computed,
            handleChangePesquisa: action,
            handleClickLimpar: action
        });

        this.createReaction(
            reaction(
                () => this.registro,
                () => {
                    this.store.carregarPecas(this.registro, this.sessaoId);
                    runInAction(() => (this.valorCampoPesquisa = ''));
                }
            )
        );
    }

    get registro() {
        return this.observableProps.registro;
    }

    componentDidMount() {
        if (this.registro && !this.pecasProcesso) {
            this.store.carregarPecas(this.registro, this.sessaoId);
        }
    }

    get sessaoId() {
        return this.observableProps.sessaoId || this.registro.sessaoId;
    }

    async abrirDocumento(documento) {
        let mimeType = documento.tipoArquivo === 'PDF' ? 'application/pdf' : 'text/html';
        let conteudo = await this.processoService.recuperarConteudoDocumento(
            this.sessaoId,
            this.registro.processo.numeroCompleto,
            documento.tipoArquivo,
            documento.id
        );
        let link = document.createElement('a');
        document.body.appendChild(link);
        link.download = documento.tipoDocumento + (documento.tipoArquivo === 'PDF' ? '.pdf' : '.html');
        link.href = URL.createObjectURL(new Blob([conteudo], { type: mimeType }));
        link.click();
        document.body.removeChild(link);
    }

    sublinhar = (documento) => {
        documento.sublinhado = 'underline';
    };

    retirarSublinhar = () => {
        this.pecasProcesso.forEach((peca) => {
            peca.sublinhado = '';
        });
    };

    get pecasProcesso() {
        return (
            this.registro.pecas &&
            this.registro.pecas.filter(
                (documento) =>
                    this.normalizarString(documento.tipoDocumento).indexOf(
                        this.normalizarString(this.valorCampoPesquisa)
                    ) !== -1 || this.descricaoDataHoraPeca(documento).indexOf(this.valorCampoPesquisa) !== -1
            )
        );
    }

    handleChangePesquisa = (event) => {
        this.valorCampoPesquisa = event.target.value;
    };

    handleClickLimpar = () => {
        this.valorCampoPesquisa = '';
    };

    textDecoration(documento) {
        return ((documento.excluido ? 'line-through ' : '') + documento.sublinhado).trim();
    }

    isAdicionadaAposApreciacao(documento) {
        const dataDocumentoObj = dayjs(documento.data, Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO);
        const dataReferenciaObj = dayjs(this.registro.dataJulgamento, Configuracao.FORMATO_DATAHORA_SERVICOS_PADRAO);

        return dataDocumentoObj.isAfter(dataReferenciaObj);
    }

    render() {
        return (
            <div style={{ display: 'flex', flexGrow: 1, flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: '14px' }}>
                    <TextField
                        label="Pesquisar peça por descrição ou data"
                        value={this.valorCampoPesquisa}
                        onChange={this.handleChangePesquisa}
                        style={{ width: '490px' }}
                    />
                    <Tooltip
                        title={<Typography>Limpar pesquisa</Typography>}
                        placement="top"
                    >
                        <span>
                            <IconeLimpar
                                style={{ cursor: 'pointer', margin: '8px 10px', minWidth: '24px' }}
                                onClick={this.handleClickLimpar}
                            />
                        </span>
                    </Tooltip>
                </div>
                <div style={{ display: 'flex', flexGrow: 1, overflowY: 'auto' }}>
                    <List style={{ display: 'flex', flexDirection: 'column', minHeight: '90px', maxHeight: '40px' }}>
                        {this.pecasProcesso && this.pecasProcesso.length > 0 ? (
                            this.pecasProcesso.map((documento) => (
                                <Box
                                    key={`peca_${documento.id}`}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        textDecoration: this.textDecoration(documento),
                                        minHeight: '44px',
                                        lineHeight: '1.5',
                                        color: documento.peticaoPendente ? red[900] : lightBlue[900],
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={this.sublinhar.bind(this, documento)}
                                    onMouseLeave={this.retirarSublinhar}
                                    onClick={() => this.abrirDocumento(documento)}
                                >
                                    {this.descricaoPeca(documento)}
                                    {documento.peticaoPendente && (
                                        <Tooltip
                                            sx={{ ml: 2, cursor: 'pointer' }}
                                            title={
                                                <Typography>
                                                    {documento.statusPeticao
                                                        ? `Petição pendente: ${documento.statusPeticao}`
                                                        : 'Petição pendente'}
                                                </Typography>
                                            }
                                        >
                                            <FilterNone sx={{ ml: 0.5, height: '20px' }} />
                                        </Tooltip>
                                    )}
                                    {this.isAdicionadaAposApreciacao(documento) && (
                                        <Tooltip
                                            sx={{ ml: 2, cursor: 'pointer' }}
                                            title={
                                                <Typography>Peça adicionada após a apreciação do processo</Typography>
                                            }
                                        >
                                            <UpdateIcon sx={{ ml: 0.5, height: '20px', fill: 'darkorange' }} />
                                        </Tooltip>
                                    )}
                                </Box>
                            ))
                        ) : !this.pecasProcesso && this.appStore.requisicoesPendentes ? (
                            <CircularProgress
                                sx={{ m: 2 }}
                                disableShrink={true}
                                size={48}
                            />
                        ) : (
                            <Box>
                                <Typography
                                    color={red[900]}
                                >{`Não há peças no processo${this.valorCampoPesquisa ? ' com o texto informado no campo de pesquisa.' : '.'}`}</Typography>
                            </Box>
                        )}
                    </List>
                </div>
            </div>
        );
    }
}

export default inject('stores')(observer(PecasProcesso));
